import axios from 'axios';
import history from '../history'
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from 'graphql-tag';
import { pageNumber, escapeHtml } from '../common/node'
import { store } from "../store";
import { setContext } from 'apollo-link-context';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

const authLink = setContext((_, { headers }) => {
  const token = cookies.get('api_access_token')
  return {
    headers: {
      ...headers,
      authorization: token ? token : null,
      'X-Locale': cookies.get('locale')
    }
  }
});

const client = new ApolloClient({
  link: authLink.concat(new HttpLink({ uri: process.env.REACT_APP_NODE_API_HOST + 'graphql' })),
  cache: new InMemoryCache(),
});

export const fetchInitialNodes = locale => {
  return (dispatch) => {
    dispatch(loadNodes(true))
    client.query({
      query: gql`
        query fetchInitialNodes{
          InitialNodes {
            id
            text
            stamps {
              message
              count
            }
            locale
            children {
              id
              text
              html
              owner_name
            }
          }
          UserRanks {
            name
            rank
          }
        }
      `,
      variables: {
        cache_key: locale,
        expires_in: 60,
      }
    }).then(response => {
      dispatch(loadNodes(false))
      cookies.set('locale', response.data.InitialNodes.locale, { path: '/' })
      dispatch(fetchInitialSuccess(response.data))
      return
    }).catch(error => {
      console.error(error)
      dispatch(fetchInitialNodes('clear'))
    });
  }
}

export const loadNodes = status => ({
  type: 'LOAD_NODES',
  isLoading: status
});

export const fetchInitialSuccess = response => ({
  type: 'FETCH_INITIAL_SUCCESS',
  response
});

export const fetchInitialMineLiked = () => {
  return (dispatch) => {
    client.query({
      query: gql`
        query fetchInitialMineLiked{
          InitialMineLiked {
            id
            liked
            mine
            children {
              id
              liked
              mine
            }
          }
        }
      `,
    }).then(response => {
      dispatch(fetchInitialMineLikedSuccess(response.data.InitialMineLiked))
      return
    }).catch(error => console.error(error));
  }
}

export const fetchInitialMineLikedSuccess = response => ({
  type: 'FETCH_INITIAL_MINE_LIKED_SUCCESS',
  response
});

export const fetchNotifications = () => {
  return (dispatch) => {
    client.query({
      query: gql`
        query fetchNotifications{
          Notifications{
            status
            from {
              name
            }
            message
            node {
              id
              text
            }
          }
        }
      `,
    }).then(response => {
      dispatch(fetchNotificationsSuccess(response.data.Notifications))
      return
    }).catch(error => console.error(error));
  }
}

export const fetchNotificationsSuccess = response => ({
  type: 'FETCH_NOTIFICATIONS_SUCCESS',
  response
});

export const fetchChildren = (ids, parent_id, page) => {
  return (dispatch) => {
    client.query({
      query: gql`
        query fetchChildren{
          Nodes(ids: "${ids}") {
            id
            children{
              id
              text
              html
              owner_name
            }
            stamps {
              message
              count
            }
          }
        }
      `,
      variables: {
        cache_key: ['fc', parent_id, page],
        expires_in: 60,
      }
    }).then(response => {
      dispatch(fetchChildrenSuccess(response.data.Nodes))
      return
    }).catch(error => console.error(error));
  }
}

export const fetchChildrenSuccess = contents => ({
    type: 'FETCH_CHILDREN_SUCCESS',
    contents
});

export const getFetchChildrenErrors = response => ({
    type: 'GET_FETCH_ERRORS',
    response
});

export const fetchChildrenMineLiked = ids => {
  return (dispatch) => {
    client.query({
      query: gql`
        query fetchChildrenMineLiked{
          Nodes(ids: "${ids}") {
            children{
              id
              liked
              mine
            }
          }
        }
      `,
    }).then(response => {
      dispatch(fetchChildrenMineLikedSuccess(response.data.Nodes))
      return
    }).catch(error => console.error(error));
  }
}

export const fetchChildrenMineLikedSuccess = contents => ({
    type: 'FETCH_CHILDREN_MINE_LIKED_SUCCESS',
    contents
});

export const fetchNodes = (id, root) => {
  return (dispatch) => {
    client.query({
      query: gql`
        query fetchNodes{
          Nodes(ids: "${id}") {
            id
            text
            html
            owner_name
            number(root: ${root})
            stamps {
              message
              count
            }
            children {
              id
              text
              html
              owner_name
            }
            ancients {
              id
              text
              html
              owner_name
            }
          }
        }
      `,
      variables: {
        cache_key: ['fn',id, root],
        expires_in: 60,
      }
    }).then(response => {
      dispatch(fetchNodesSuccess(response.data.Nodes[0]))
      return
    }).catch(error => console.error(error));
  }
}

export const fetchNodesSuccess = response => ({
  type: 'FETCH_NODES_SUCCESS',
  response
});

export const getFetchNodesErrors = response => ({
  type: 'GET_FETCH_ERRORS',
  response
});


export const fetchNodesMineLiked = id => {
  return (dispatch) => {
    client.query({
      query: gql`
        query fetchNodesMineLiked{
          Nodes(ids: "${id}") {
            id
            liked
            mine
            children {
              id
              liked
              mine
            }
            ancients {
              id
              liked
              mine
            }
          }
        }
      `,
    }).then(response => {
      dispatch(fetchNodesMineLikedSuccess(response.data.Nodes[0]))
      return
    }).catch(error => console.error(error));
  }
}

export const fetchNodesMineLikedSuccess = response => ({
  type: 'FETCH_NODES_MINE_LIKED_SUCCESS',
  response
});


export const nextPage = (number, root, id, page, children) => {
  if(children.length >= (page + (pageNumber(root) * 2))) {
    return ({
      type: 'NEXT_PAGE_SUCCESS',
      number: number, root: root,
    })
  }
  return (dispatch) => {
    client.query({
      query: gql`
        query nextPage{
          Nodes(ids: "${id}") {
            id
            children(page: ${page}){
              id
              text
              html
              owner_name
            }
          }
        }
      `,
      variables: {
        cache_key: ['np', id, page],
        expires_in: 5,
      }
    })
      .then(response => {
      dispatch(fetchNextPageSuccess(response.data.Nodes[0], number, root))
      if(cookies.get('api_access_token') === 'undefined' || cookies.get('api_access_token') == null) {
        return
      }
      dispatch(nextPageMineLiked(number, root, id, page, children))
      return
      })
      .catch(error => console.error(error));
  }
}

export const fetchNextPageSuccess = (response, number, root) => ({
  type: 'FETCH_NEXT_PAGE_SUCCESS',
  number: number, root: root,
  response
});

export const nextPageMineLiked = (number, root, id, page, children) => {
  if(children.length >= (page + (pageNumber(root) * 2))) {
    return({type: null})
  }
  return (dispatch) => {
    client.query({
      query: gql`
        query nextPageMineLiked{
          Nodes(ids: "${id}") {
            children(page: ${page}){
              id
              liked
              mine
            }
          }
        }
      `,
    })
      .then(response => {
      dispatch(fetchNextPageMineLikedSuccess(response.data.Nodes[0], number, root))
      return
      })
      .catch(error => console.error(error));
  }
}

export const fetchNextPageMineLikedSuccess = (response, number, root) => ({
  type: 'FETCH_NEXT_PAGE_MINE_LIKED_SUCCESS',
  number: number, root: root,
  response
});

export const nextUserPage = (id, page, children) => {
  if(children.length >= (page + (11 * 2))) {
    return ({
      type: 'NEXT_USER_PAGE_SUCCESS',
    })
  }
  return (dispatch) => {
    client.query({
      query: gql`
        query {
          UserNodes(page: ${page}){
            id
            text
            html
            liked
          }
        }
      `,
    })
      .then(response => {
      dispatch(fetchNextUserPageSuccess(response.data.UserNodes))
      return
      })
      .catch(error => console.error(error));
  }
}

export const fetchNextUserPageSuccess = response => ({
  type: 'FETCH_NEXT_USER_PAGE_SUCCESS',
  response
});

export const nextLikedPage = (id, page, children) => {
  if(children.length >= (page + (11 * 2))) {
    return ({
      type: 'NEXT_LIKED_PAGE_SUCCESS',
    })
  }
  return (dispatch) => {
    client.query({
      query: gql`
        query {
          LikedNodes(page: ${page}){
            id
            text
            html
            owner_name
            mine
          }
        }
      `,
    })
      .then(response => {
      dispatch(fetchNextLikedPageSuccess(response.data.LikedNodes))
      return
      })
      .catch(error => console.error(error));
  }
}

export const fetchNextLikedPageSuccess = response => ({
  type: 'FETCH_NEXT_LIKED_PAGE_SUCCESS',
  response
});

export const createNodeSuccess = (response, id, number) => ({
  type: 'CREATE_NODE_SUCCESS',
  parent_id: id, number: number,
  response
});

export const createNode = (node, parent_id, number) => {
  return (dispatch) => {
    client.mutate({
      mutation: gql`
        mutation {
          AddNode(node:{
            parent_id: "${parent_id}",
            text: "${escapeHtml(node.text)}",
            })
          {
            id
            text
          }
        }
      `,
    })
      .then(response => {
      dispatch(createNodeSuccess(response.data.AddNode, parent_id, number))
      return
      })
      .catch(error => console.error(error));
  }
}

export const editNodeSuccess = (response, id, number) => ({
  type: 'EDIT_NODE_SUCCESS',
  id: id, number: number,
  response
});

export const editNode = (node, id, number) => {
  return (dispatch) => {
    client.mutate({
      mutation: gql`
        mutation {
          EditNode(id:"${id}", node:{
            text: "${escapeHtml(node.editText)}",
            })
          {
            id
            text
            mine
            owner_name
            liked
          }
        }
      `,
    })
      .then(response => {
      dispatch(editNodeSuccess(response.data.EditNode, id, number))
      return
      })
      .catch(error => console.error(error));
  }
}

export const fetchUserNodes = page => {
  return (dispatch) => {
    client.query({
      query: gql`
        query {
          UserNodes(page: 0){
            id
            text
            html
            liked
            mine
          }
          LikedNodes(page: 0){
            id
            text
            html
            owner_name
            mine
          }
        }
      `,
    })
      .then(response => {
        dispatch(fetchUserNodesSuccess(response.data))
        return
      })
      .catch(error => console.error(error));
  }
}

export const fetchUserNodesSuccess = response => ({
  type: 'FETCH_USER_NODES_SUCCESS',
  user: cookies.get('name'),
  response
});

export const likeNode = id => {
  return (dispatch) => {
    client.mutate({
      mutation: gql`
        mutation {
          LikeNode(id: "${id}") {
            id
            liked
          }
        }
      `,
    })
      .then(response => {
      dispatch(likeNodeSuccess(response.data.LikeNode))
      return
      })
      .catch(error => console.error(error));
  }
}

export const likeNodeSuccess = response => ({
  type: 'LIKE_NODE_SUCCESS',
  response
});

export const updateNotifications = () => {
  return (dispatch) => {
    client.mutate({
      mutation: gql`
        mutation {
          UpdateNotifications
        }
      `,
    })
      .then(response => {
      dispatch(updateNotificationsSuccess())
      return
      })
      .catch(error => console.error(error));
  }
}

export const updateNotificationsSuccess = () => ({
  type: 'UPDATE_NOTIFICATIONS_SUCCESS'
});

export const deleteNode = (id, number) => {
  return (dispatch) => {
    client.mutate({
      mutation: gql`
        mutation {
          DeleteNode(id: "${id}")
        }
      `,
    })
      .then(response => {
        let parent = store.getState().server.parent[id]
        dispatch(deleteNodeSuccess(id, number))
        history.push('/nodes/' + parent)
        return
      })
      .catch(error => console.error(error));
  }
}

export const deleteNodeSuccess = (id, number) => ({
  type: 'DELETE_NODE_SUCCESS',
  id: id, number: number, root: false
});

export const createUserSuccess = response => {
  history.push('/signup/email')
  return ({
    type: 'CREATE_USER_SUCCESS'
  })
};

export const createUser = (email, password, recaptcha, locale) => {
  return (dispatch) => {
    axios.defaults.headers['X-Locale'] = locale;
    axios
      .post(process.env.REACT_APP_NODE_API_HOST + 'api/v1/users/', {
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Locale': locale
        }),
        'g-recaptcha-response': recaptcha,
        user: {
          email: email,
          password: password
        }
      })
      .then(response => {
        dispatch(createUserSuccess(response))
        return
      })
      .catch(error => dispatch(getUserErrors(error.response.data.error)));
  }
}

export const getUserErrors = (response) => ({
  type: 'GET_USER_ERRORS',
  response
});

export const confirmUsersSuccess = response => {
  history.push('/')
  return ({
    type: 'CONFIRM_USERS_SUCCESS',
    response
  })
}

export const confirmUsers = (token, locale) => {
  return (dispatch) => {
    axios.defaults.headers['X-Locale'] = locale;
    axios.get(process.env.REACT_APP_NODE_API_HOST + "users/confirmation?confirmation_token=" + token, {
      headers: new Headers({
        'Content-Type': 'application/x-www-form-urlencoded',
        'X-Locale': locale
      })
    })
      .then(response => {
        cookies.set('api_access_token', response.data.access_token, { path: '/' })
        cookies.set('name', response.data.name, { path: '/' })
        if(typeof cookies.get('lastClickedId') === 'undefined' || cookies.get('lastClickedId') === 'null') {
          history.push("/")
        } else {
          history.push("/nodes/"+ cookies.get('lastClickedId'))
        }
        return
      })
      .catch(error => dispatch(getConfirmErrors(JSON.stringify(error.response.data))));
  }
}

export const getConfirmErrors = response => ({
  type: 'GET_CONFIRM_ERRORS',
  response
})

export const loginUser = (email, password, locale) => {
  return (dispatch) => {
    axios.defaults.headers['X-Locale'] = locale;
    axios
      .post(process.env.REACT_APP_NODE_API_HOST + 'api/v1/login', {
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Locale': locale
        }),
        user: {
          email: email,
          password: password
        }
      })
      .then(response => {
        if(typeof response.data.access_token === 'undefined') {
          dispatch(getUserErrors(response.data.error))
        } else {
          dispatch(getLoginUserSuccess())
          cookies.set('api_access_token', response.data.access_token, { path: '/' })
          cookies.set('name', response.data.name, { path: '/' })
          if(typeof cookies.get('lastClickedId') !== 'undefined' && cookies.get('lastClickedId').length > 4 ) {
            history.push("/nodes/"+ cookies.get('lastClickedId'))
          } else {
            history.push("/")
          }
        }
        return
      })
      .catch(error => dispatch(getUserErrors(error.response.data.error)));
  }
}

export const getLoginUserSuccess = () => ({
  type: 'LOGIN_USER_SUCCESS',
})

export const forgotPassword = (email, locale) => {
  return (dispatch) => {
    axios.defaults.headers['X-Locale'] = locale;
    axios
      .post(process.env.REACT_APP_NODE_API_HOST + 'users/password', {
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Locale': locale
        }),
        user: {
          email: email
        }
      })
      .then(response => {
        dispatch(forgotPasswordSuccess(response))
        return
      })
      .catch(error => dispatch(forgotPasswordErrors(error.response.data)));
  }
}

export const forgotPasswordSuccess = response => {
  history.push('/users/forgot/email')
  return ({
    type: 'FORGOT_PASSWORD_SUCCESS'
  })
}

export const forgotPasswordErrors = response => ({
  type: 'FORGOT_PASSWORD_ERRORS',
  response
})

export const resetPassword = (password, token, locale) => {
  return (dispatch) => {
    dispatch(loadNodes(true))
    axios.defaults.headers['X-Locale'] = locale;
    axios
      .patch(process.env.REACT_APP_NODE_API_HOST + 'users/password', {
        headers: new Headers({
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Locale': locale
        }),
        user: {
          reset_password_token: token,
          password: password
        }
      })
      .then(response => {
        dispatch(loadNodes(false))
        dispatch(resetPasswordSuccess(response))
        return
      })
      .catch(error => dispatch(resetPasswordErrors(error.response.data)));
  }
}

export const resetPasswordSuccess = response => {
  cookies.set('api_access_token', response.data.access_token, { path: '/' })
  cookies.set('name', response.data.name, { path: '/' })
  history.push('/')
  return ({
    type: 'RESET_PASSWORD_SUCCESS'
  })
}

export const resetPasswordErrors = response => ({
  type: 'RESET_PASSWORD_ERRORS',
  response
})

export const fetchNoderNodes = name => {
  return (dispatch) => {
    dispatch(loadNodes(true))
    client.query({
      query: gql`
        query fetchNoderNodes{
          NoderNodes(name: "${name}"){
            id
            text
            html
            liked
            mine
          }
        }
      `,
    })
    .then(response => {
      dispatch(loadNodes(false))
      dispatch(fetchNoderNodesSuccess(response.data.NoderNodes, name))
      return
    })
    .catch(error => console.error(error));
  }
}

export const fetchNoderNodesSuccess = (response, name) => ({
  type: 'FETCH_NODER_NODES_SUCCESS', name: name,
  locale: cookies.get('locale'),
  response
});

export const stampNodeSuccess = (response, id, message, number) => ({
  type: 'STAMP_NODE_SUCCESS',
  id: id, message: message, number: number,
  response
});


export const stampNode = (id, message, count, number) => {
  return (dispatch) => {
    client.mutate({
      mutation: gql`
        mutation {
          UpdateStamp(
            id: "${id}", message: "${message}", count: "${count}"
            )
          {
            count
          }
        }
      `,
      variables: {
        cache_key: 'clear'
      }
    })
      .then(response => {
      dispatch(stampNodeSuccess(response.data.UpdateStamp, id, message, number))
      return
      })
      .catch(error => console.error(error));
  }
}




// WEBPACK FOOTER //
// ./src/actions/asyncs.js